import { formatAmount, formatNumberWithSpaces } from '~/@lib/utils/number.utils'
import { allowedProjectPaymentTypes } from '~/@pages_investing/projects/_projects_ui/project-payment-type-label/allowedProjectPaymentTypes'
import { getProjectPaymentTypeLabel } from '../_projects_ui/project-payment-type-label/getProjectPaymentTypeLabel'

export const ltlOptions = [
  { label: '< 40%', value: { max: 40 } },
  { label: '40 - 49%', value: { min: 40, max: 49 } },
  { label: '50 - 59%', value: { min: 50, max: 59 } },
  { label: '60 - 69%', value: { min: 60, max: 69 } },
  { label: '70 - 79%', value: { min: 70, max: 79 } },
  { label: '> 79%', value: { min: 79 } },
]

export const riskOptions = [
  { label: '< 5', value: { max: 5 } },
  { label: '5 - 6', value: { min: 5, max: 6 } },
  { label: '6 - 8', value: { min: 6, max: 8 } },
  { label: '8 - 10', value: { min: 8 } },
]

export const investmentPeriodOptions = [
  { label: '< 3 M', value: { max: 3 } },
  { label: '3 - 6 M', value: { min: 3, max: 6 } },
  { label: '6 - 12 M', value: { min: 6, max: 12 } },
  { label: '12 - 18 M', value: { min: 12, max: 18 } },
  { label: '18 - 24 M', value: { min: 18, max: 24 } },
  { label: '24 - 30 M', value: { min: 24, max: 30 } },
  { label: '30 - 36 M', value: { min: 30, max: 36 } },
  { label: '> 36 M', value: { min: 36 } },
]

export const getPaymentTypeOptions = () => {
  return allowedProjectPaymentTypes.map((paymentType) => {
    return {
      value: paymentType,
      label: getProjectPaymentTypeLabel(paymentType),
    }
  })
}

export const amountTargetOptions = [
  { label: `< ${formatAmount(100_000)}`, value: { max: 100_000 } },
  {
    label: `${formatNumberWithSpaces(100_000)} - ${formatAmount(250_000)}`,
    value: { min: 100_000, max: 250_000 },
  },
  {
    label: `${formatNumberWithSpaces(250_000)} - ${formatAmount(500_000)}`,
    value: { min: 250_000, max: 500_000 },
  },
  { label: `> ${formatAmount(500_000)}`, value: { min: 500_000 } },
]
